(function(window, document, $) {
	"use strict";
	var formHandler = {
		init: function() {
			this.bindEvents();
		},
		bindEvents: function() {
			$(document).on('keydown', function(e) {
				//Honeypot tab index if people starts use keyboard
				$('.interests-field input').attr('tabindex', '-1');
			});
		}
	};

	$(document).ready(function() {
		formHandler.init();
	});
})(window, document, jQuery);

